_collow.components.SelectGroupStepPage = class SelectGroupStepPage extends _collow.components.Base {
    root;
    elements;
    params;
    allGroups;
    currentStepNumber;
    groupSelected;
    selectTag;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.selectTag = this.elements.groupSelect;
      this.groupSelected = "null";

      this.getGroups();
      this.listen(document, "_init-select-group-step", this.initSelectGroupStep);
      this.selectTag.addEventListener("change", (e) => this.handleSelectGroup(e))
    }

    getGroups = async () => {
      const page = window.document.body
      page.classList.add("loading")
  
      const response = await fetch(this.params.path + "/admin/group/all", {
        method: "GET",
          headers: {
            Authorization: window.localStorage.getItem("token"),
          },
      });
      if (!response.ok) {
        console.error("Unable to fetch groups - msg: " + response)
      }
      const list_all_groups = await response.json()
      page.classList.remove("loading")
  
      this.allGroups = list_all_groups;
      this.displayGroupList(list_all_groups);
    }

    displayGroupList = (groups) => {
      const groupSelect = this.elements.groupSelect;
      groupSelect.textContent = '';

      const firstOption = document.createElement('option');

      if(this.params.language === "en") {
        firstOption.textContent = "Select group(s)"
      } else if(this.params.language === "nl") {
        firstOption.textContent = "Kies groep(en)"
      }
      firstOption.value = ""
      groupSelect.append(firstOption);
  
      groups.forEach(group => {
        const groupName = group.name
        const tableRow = document.createRange().createContextualFragment(`
          <option class="table-checkbox" value="${groupName}">${groupName}</option>
          `);
          groupSelect.append(tableRow);
      })
    };

    initSelectGroupStep = () => {
      this.currentStepNumber = document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1];
      this.toogleNextBtn(this.groupSelected)
    }

    handleSelectGroup = (e) => {
      this.groupSelected = e.target.value
      this.currentStepNumber = document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1];
      this.toogleNextBtn(this.groupSelected)
    }

    toogleNextBtn = (groupSelected) => {
      if(groupSelected.length == 0) {
        this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: true, data: "null"});
      } else {
        this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: true, data: groupSelected});
      }
    }
};
  
   
  
  
  
  
  
  